import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmService, DialogHelper, DialogWidth, HttpLoaderService, SnackbarService, localDateTimePipe} from '@tymes4-shared';
import {TranslateService} from '@ngx-translate/core';
import {PassePartoutPositionView, PassePartoutService} from '../../api';
import {TicketAssignmentHistoryComponent} from '../../components/customer-tickets/ticket-assignment-history/ticket-assignment-history.component';
import {ApplicationModuleHelperService, ApplicationModules} from '../../services/application-module.service';
import {CustomerRevokeFormComponent} from '../customer-revoke-form/customer-revoke-form.component';

export enum TicketSwapStatusEnum {
  None = "None",
  Offered = "Offered",
  Accepted = "Accepted",
  Sold = "Sold",
  Withdrawn = "Withdrawn",
  Revoked = "Revoked",
  PendingInvitation = "PendingInvitation",
  InvitationDeclined = "InvitationDeclined",
  Assigned = "Assigned",
  AssignmentRequired = "AssignmentRequired",
  GuestAssignment = "GuestAssignment",
  ReIssued = "ReIssued"
}

const TICKET_SWAP_STATUS_CLASSES: Partial<Record<TicketSwapStatusEnum, string[]>> = {
  [TicketSwapStatusEnum.Offered]: ['chipbox', 'chipbox-open'],
  [TicketSwapStatusEnum.Accepted]: ['chipbox', 'chipbox-open'],
  [TicketSwapStatusEnum.Sold]: ['chipbox', 'chipbox-open'],
  [TicketSwapStatusEnum.Withdrawn]: ['chipbox', 'chipbox-closed'],
  [TicketSwapStatusEnum.Revoked]: ['chipbox', 'chipbox-closed'],
  [TicketSwapStatusEnum.InvitationDeclined]: ['chipbox', 'chipbox-closed'],
  [TicketSwapStatusEnum.PendingInvitation]: ['chipbox', 'chipbox-warning'],
  [TicketSwapStatusEnum.AssignmentRequired]: ['chipbox', 'chipbox-warning'],
  [TicketSwapStatusEnum.Assigned]: ['chipbox', 'chipbox-primary'],
  [TicketSwapStatusEnum.GuestAssignment]: ['chipbox', 'chipbox-primary'],
  [TicketSwapStatusEnum.ReIssued]: ['chipbox', 'chipbox-inactive'],
};

@Component({
    selector: 'app-customer-passepartout-positions',
    templateUrl: './customer-passepartout-positions.component.html',
    styleUrls: ['./customer-passepartout-positions.component.scss'],
    standalone: false
})
export class CustomerPassepartoutPositionsComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<CustomerPassepartoutPositionsComponent>,
              private confirmService: ConfirmService,
              private passePartoutService: PassePartoutService,
              private loader: HttpLoaderService,
              private snackBar: SnackbarService,
              private translate: TranslateService,
              private localDateTimePipe: localDateTimePipe,
              private dialog: MatDialog,
              private moduleService: ApplicationModuleHelperService,
            ) {
  }

  public listOptions;
  public secondaryTicketingActive: boolean = false;
  private checkedTicketSwapStatus: boolean = false;
  public ibaActive: boolean;

  @ViewChild('listVw') listVw;

  public customerPassePartout: any = null;
  public customerId = null;

  ngOnInit() {

    this.customerPassePartout = this.passedData.payload.customerPassePartout;
    this.customerId = this.passedData.payload.customerId;

    this.listOptions = {
      search: false,
      showBarcodeSearch: false,
      pageSize: 12,
      noItemsText: this.translate.instant('DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.NO-ITEMS-TEXT'),
      multiSelectMode: false,
      disableSort: true,
      disableSelect: true,
      headers: [
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.NUMBER', width: 90, hideOn: null},
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.DATE', width: 110, hideOn: null},
        {sortField: null, label: '', width: 70, hideOn: null},
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.EVENT', width: 330, hideOn: null},
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.SECTION', width: 90, hideOn: null},
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.ROW-AND-SEAT', width: 120, hideOn: null},
        {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.BARCODE', width: 240, hideOn: null},
      ]
    };

    this.moduleService.getActiveModules().subscribe(activeModules => {
      if (activeModules) {
        this.ibaActive = activeModules.includes(ApplicationModules.IBA);
      }
    })
  }

  OnDataRequest(e) {
    this.loader.open();

    this.passePartoutService.getPassePartoutPositions(this.customerPassePartout.Id, this.customerId).subscribe((data: Array<PassePartoutPositionView>) => {
      if (!this.checkedTicketSwapStatus) {
        data.forEach(position => {
          if (position.LatestTicketSwapStatus != TicketSwapStatusEnum.None && !this.checkedTicketSwapStatus) {
            this.listOptions.headers.push({sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.STATUS', width: 80})
            this.checkedTicketSwapStatus = true;
            this.secondaryTicketingActive = true;
          }
        })
        this.listOptions.headers.push(
          {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.REASON', width: 200, hideOn: null},
          {sortField: null, label: 'DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.LISTVIEW.HEADER.BY', hideOn: null},
          {sortField: null, label: ''},
        );
        this.listVw.setOptions(this.listOptions)
        this.listVw.refreshData();
        this.checkedTicketSwapStatus = true;
      }

      this.loader.close();

      let paged = data.slice((e.pageNr - 1) * e.pageSize, (e.pageNr) * e.pageSize);
      this.listVw.Data = {
        Records: paged,
        TotalRecords: data.length
      };

    });

  }

  getExcludeFromLinkingTimestamp() {
    const localTime = this.localDateTimePipe.transform(this.customerPassePartout.ExcludeFromLinkingTimestamp);
    return this.translate.instant('COMPONENTS.CUSTOMER-PASSEPARTOUTS.EXCLUDE-FROM-LINKING.TIMESTAMP', { timeStamp: localTime });
  }

  getExcludeFromLinkingBy() {
    return this.translate.instant('COMPONENTS.CUSTOMER-PASSEPARTOUTS.EXCLUDE-FROM-LINKING.BY', { name: this.customerPassePartout.ExcludeFromLinkingUserName });
  }

  confirmDelete(i) {

    let seat = i.SeatNumber == null ? '-' : i.SeatNumber;
    let row = i.RowNumber == null ? '-' : i.RowNumber;

    let confirmTxt = this.translate.instant('DIALOGS.CUSTOMER-PASSEPARTOUT-POSITIONS.CONFIRM.WARNING.DELETE-POSITION', {iEventName: i.EventName, iParentShortName: i.ParentShortName, row: row, seat: seat});

    this.passePartoutService.canRemovePosition(i.CustomerPassePartoutId, i.EventPlacementId).subscribe((result: boolean) => {
      if (!result) {
        this.confirmService.confirm({
          title: this.translate.instant('GENERIC.CONFIRM.ERROR.SECONDARY-TICKETS.TITLE'),
          message: this.translate.instant('GENERIC.CONFIRM.ERROR.SECONDARY-TICKETS.MSG'),
          okonly: true
        }).subscribe();

        return;
      }
      this.confirmService.confirm({
        title: this.translate.instant('GENERIC.CONFIRM.CONFIRM'),
        message: confirmTxt,
        okonly: false
      }).subscribe((confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.loader.open();
        this.passePartoutService.deletePosition(i.CustomerPassePartoutId, i.EventPlacementId).subscribe(() => {
          this.loader.close();
          this.listVw.refreshData();
          this.snackBar.open(this.translate.instant('GENERIC.SNACKBAR.POSITION-DELETED'), 'GENERIC.SNACKBAR.CLOSE');
        });
      });
    });
  }

  itemDeletable(item) {
    if (!item.Deletable) {
      return false;
    }

    if (item.LatestTicketSwapStatus != null) {
      const deletableStatuses: TicketSwapStatusEnum[] = [TicketSwapStatusEnum.Accepted, TicketSwapStatusEnum.Offered, TicketSwapStatusEnum.Sold];
      return !deletableStatuses.includes(item.LatestTicketSwapStatus);
    }

    return true;
  }

  getTicketSwapStatusClass(status: TicketSwapStatusEnum) {
    return TICKET_SWAP_STATUS_CLASSES[status] ?? [];
  }

  openAssignmentHistory(eventPlacementId: number) {
    const options = DialogHelper.GetDialogOptions(DialogWidth.full, {
      eventPlacementId: eventPlacementId,
      customerId: this.customerId
    });

    this.dialog.open(TicketAssignmentHistoryComponent, options);
  }

  revoke(item: PassePartoutPositionView) {

    const options = DialogHelper.GetDialogOptions(DialogWidth.md, {
      ticket: item,
      customerId: this.customerId
     });

    const dialogRef: MatDialogRef<any> = this.dialog.open(CustomerRevokeFormComponent, options);

    dialogRef.afterClosed().subscribe(() => {
        this.listVw.refreshData();
    });
  }

  toggleExcludeFromLinking() {
    if (this.customerPassePartout.ExcludeFromLinking) {
      return;
    }

    this.confirmService.confirm({
      title: this.translate.instant('COMPONENTS.CUSTOMER-PASSEPARTOUTS.CONFIRM.TITLE.EXCLUDE-FROM-LINKING'),
      message: this.translate.instant('COMPONENTS.CUSTOMER-PASSEPARTOUTS.CONFIRM.MESSAGE.EXCLUDE-FROM-LINKING'),
      okonly: true})
      .subscribe((confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.loader.open();
        this.passePartoutService.activateExcludeFromLinking(this.customerPassePartout.Id).subscribe(() => {
          this.customerPassePartout.ExcludeFromLinking = true;
          this.loader.close();
          this.dialogRef.close();
        });
      });
  }
}
